import { render } from "./EditClients.vue?vue&type=template&id=01e2f0b7"
import script from "./EditClients.vue?vue&type=script&lang=js"
export * from "./EditClients.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__